import client from '../client';
import endpoints from '../endpoints';

/**
 * 이미지 관리 API
 *
 * POST   /api/upload                          — 이미지 파일 업로드 → { url } 반환
 * POST   /api/admin/images                    — 이미지 등록 (entity_type, entity_id, image_url)
 * GET    /api/admin/images?entity_type=&entity_id= — 이미지 목록 조회 (관리자)
 * GET    /api/images?entity_type=&entity_id=  — 이미지 목록 조회 (Public)
 * PUT    /api/admin/images/{id}               — 이미지 수정
 * DELETE /api/admin/images/{id}               — 이미지 삭제
 */

/** POST /api/upload — 파일 업로드 후 { url } 반환 */
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await client.post(endpoints.upload, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data; // { url: '...' }
};

/** POST /api/admin/images — 이미지 메타 등록 */
export const createImage = async (data) => {
  // data: { entity_type, entity_id, image_url, sort_order? }
  const res = await client.post(endpoints.admin.images.list, data);
  return res.data;
};

/** GET /api/admin/images?entity_type=vehicle&entity_id=1 — 관리자용 엔티티별 이미지 목록 */
export const getImages = async (params = {}) => {
  const res = await client.get(endpoints.admin.images.list, { params });
  return res.data;
};

/** GET /api/images?entity_type=&entity_id= — Public 엔티티별 이미지 목록 */
export const getPublicImages = async (params = {}) => {
  const res = await client.get('/api/images', { params });
  return res.data;
};

/** PUT /api/admin/images/{id} — 이미지 수정 */
export const updateImage = async (id, data) => {
  const res = await client.put(endpoints.admin.images.detail(id), data);
  return res.data;
};

/** DELETE /api/admin/images/{id} — 이미지 삭제 */
export const deleteImage = async (id) => {
  const res = await client.delete(endpoints.admin.images.detail(id));
  return res.data;
};
